import SliderSave, { SliderItemSave } from './slider-save';

export const SliderItemPreview = SliderItemSave;

const SliderPreview = SliderSave;

export default SliderPreview;
